import React from "react";
import Select from "react-select";
import { ShowErrorFromResponse } from "../../utilities/response-processor";
import { getUserTagsClient } from "../../services/api-clients.service";

interface SelectOption {
    value: number;
    label: string;
}

interface UserTagParentSelectProps {
    value?: number;
    onChange: (option: SelectOption) => void;

}


const UserTagParentSelect: React.FC<UserTagParentSelectProps> = (props) => {

    const [selectedValue, setSelectedValue] = React.useState<SelectOption>();
    const [options, setOptions] = React.useState<SelectOption[]>([]);

    React.useEffect(() => {
        getOptions();
    }, []);

    React.useEffect(() => {
        if (!!props.value) {
            const value = options.find(x => x.value == props.value);
            setSelectedValue(value);
        }

    }, [props.value, options]);
    const getOptions = async () => {
        try {
            const client = getUserTagsClient();
            const userTags = await client.getUserTags(true, null, false, 0, 10000);
            const optionsMapped = userTags?.items?.map(x => ({ value: x.id, label: x.name } as SelectOption)) ?? [];
            setOptions(optionsMapped);

        } catch (error) {
            ShowErrorFromResponse(error, "An error occurred while getting user tag options.");
        }
    }




    return <Select
        value={selectedValue}
        options={options}
        onChange={(value) => { props.onChange(value) }}
    />
}

export default UserTagParentSelect;